import { useEffect } from "react";
import { formatDistanceToNow } from "date-fns";
import { ms } from "date-fns/locale";
import { CheckCircle2, ExternalLink, Info, SkipForward, Trash2, Users, XCircle } from "lucide-react";
import { Button } from "@/components/ui/button";

export const checkedLabel = (g) => (g.checked_at ? `Disemak ${formatDistanceToNow(new Date(g.checked_at), { locale: ms, addSuffix: true })}` : "Belum pernah disemak");

export default function GroupCheckCard({ group, opened, setOpened, busy, onActive, onInactive, onDelete, onSkip }) {
  const open = () => { window.open(group.url, "_blank", "noopener,noreferrer"); setOpened(true); };

  useEffect(() => {
    const onKey = (e) => {
      if (busy || e.target.tagName === "INPUT") return;
      const k = e.key.toLowerCase();
      if (k === "enter") { e.preventDefault(); open(); }
      if (k === "a") onActive();
      if (k === "t") onInactive();
      if (k === "s") onSkip();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  });

  return (
    <div className="panel fade-up p-6 sm:p-8" data-testid="group-check-card">
      <div className="flex items-center gap-3">
        <div className="flex h-11 w-11 items-center justify-center rounded-xl bg-primary/15 text-primary"><Users className="h-5 w-5" /></div>
        <div className="min-w-0">
          <p className="truncate text-xl font-bold" data-testid="group-check-name">{group.name}</p>
          <p className="truncate font-mono text-[11px] text-muted-foreground">{group.url}</p>
        </div>
      </div>
      <p className="mt-4 text-xs text-muted-foreground" data-testid="group-check-last">
        {checkedLabel(group)}{group.check_status === "inactive" && " · ditanda tidak aktif"}
      </p>
      {group.notes && <p className="mt-3 flex items-start gap-2 rounded-lg border border-border bg-background/60 px-3 py-2 text-sm text-slate-300"><Info className="mt-0.5 h-4 w-4 shrink-0" />{group.notes}</p>}
      <Button onClick={open} disabled={busy} className="mt-6 h-12 w-full text-base font-semibold" data-testid="group-check-open-btn">
        <ExternalLink className="mr-2 h-4 w-4" /> 1. Buka Group di Facebook
      </Button>
      <p className="mt-5 text-sm font-medium">2. Group ini masih boleh digunakan?</p>
      <div className={`mt-3 grid gap-2 sm:grid-cols-2 ${opened ? "" : "opacity-80"}`}>
        <Button onClick={onActive} disabled={busy} className={`h-11 bg-emerald-600 hover:bg-emerald-500 ${opened ? "ring-2 ring-emerald-400/60" : ""}`} data-testid="group-check-active-btn">
          <CheckCircle2 className="mr-2 h-4 w-4" /> Masih aktif
        </Button>
        <Button onClick={onInactive} disabled={busy} variant="outline" className="h-11 border-amber-500/50 text-amber-300 hover:bg-amber-500/10" data-testid="group-check-inactive-btn">
          <XCircle className="mr-2 h-4 w-4" /> Tidak aktif (simpan)
        </Button>
        <Button onClick={onDelete} disabled={busy} variant="outline" className="h-11 border-red-500/40 text-red-300 hover:bg-red-500/10" data-testid="group-check-delete-btn">
          <Trash2 className="mr-2 h-4 w-4" /> Tidak aktif — padam
        </Button>
        <Button onClick={onSkip} disabled={busy} variant="ghost" className="h-11 text-muted-foreground" data-testid="group-check-skip-btn">
          <SkipForward className="mr-2 h-4 w-4" /> Langkau
        </Button>
      </div>
      <p className="mt-4 hidden font-mono text-[11px] text-muted-foreground sm:block">Pintasan: Enter = buka · A = aktif · T = tidak aktif · S = langkau</p>
    </div>
  );
}
